import { styled } from '@mui/material';

import { TAppraisalDto } from '@app-velocity/av-api-v2';

import { AppraisalGroup } from '../AppraisalGroup';

export type AppraisalCategoryProps = {
  reviews: {
    [slug: string]: TAppraisalDto[];
  };
};

const StyledAppraisalGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const AppraisalCategory = ({ reviews }: AppraisalCategoryProps) => {
  const slugs = Object.keys(reviews);

  return (
    <StyledAppraisalGroup>
      {slugs.map((slug) => (
        <AppraisalGroup key={slug} reviews={reviews[slug]} />
      ))}
    </StyledAppraisalGroup>
  );
};
